import React, { Component } from "react";

class PageNotFound extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="app-page-not-found">
        <h2 className="text-red-600 text-center">404 - Page Not Found</h2>
      </div>
    );
  }
}

export default PageNotFound;